import { useId } from "react";
import { useTranslation } from "react-i18next";
import { Field } from "@/widgets/classic-form/form";
import styles from "./ShowUnviewedRecordsOnly.module.scss";

interface ShowUnviewedRecordsOnlyProps {
    label: string;
}

export const ShowUnviewedRecordsOnly = ({ label }: ShowUnviewedRecordsOnlyProps) => {
    const { t } = useTranslation();
    const id = useId();

    return (
        <Field name="showUnviewedRecordsOnly">
            {({ value, onChange }) => (
                <div className={styles.showUnviewedRecordsOnly}>
                    <input
                        id={id}
                        type="checkbox"
                        className="checkbox"
                        checked={value}
                        onChange={() => onChange(!value)}
                        title={label}
                    />
                    <label htmlFor={id}>{label}</label>
                    <span className={styles.proBadge}>{t("showUnviewedRecordsOnly.pro")}</span>
                </div>
            )}
        </Field>
    );
};
